import React from "react";
import ClaimsList from "./dashboard_left";
import StageWiseOverview from "./Dashboard_right";
import "./MergedStyles.css";

const MergedComponents = () => {
  return (
    <>
      {/* First layout with merged-container */}
      <div className="merged-container">
        <div className="left-section">
          <ClaimsList />
        </div>
        <div className="right-section">
          <StageWiseOverview />
        </div>
      </div>
    </>
  );
};

export default MergedComponents;
